export default {"src":"/_next/static/media/scale.00c2b6d1.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};